import { Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { colors } from '../../styles';
import { t } from 'i18next';

interface IConfirmationParams {
  details: string;
}

export const Confirmation: React.FC = () => {
  let { details } = useParams<IConfirmationParams>();
  const history = useHistory();
  const goToMainPage = () => {
    history.push('/');
  };

  if (!details) {
    return (
      <Stack spacing={2} alignItems="center">
        {t('paymentError')}{' '}
      </Stack>
    );
  }
  return (
    <Grid container display="flex" justifyContent="center">
      <Stack spacing={4} alignItems="center" width="100%">
        <Typography variant="h4" textAlign="center">
          {t('paymentProcessed', { details })}
        </Typography>
        <Typography
          variant="h5"
          textAlign={'center'}
          sx={{ color: colors.blue }}
        >
          {t('paymentReceipt')}
        </Typography>
        <Button sx={{ padding: 2 }} variant="contained" onClick={goToMainPage}>
          {t('backToHome')}
        </Button>
      </Stack>
    </Grid>
  );
};
